import { OnChangeParams } from 'baseui/select';
import { useMemo } from 'react';
import { CONFIGURATION_TRIGGER_TYPE_OPTIONS } from '../../../constants/maintenances';
import { ConfigurationTriggerType } from '../../../types/maintenances';
import EnhancedLabeledSelect from '../../ui/EnhancedLabeledSelect';

type Props = {
  selectedId?: ConfigurationTriggerType;
  onChangeId?: (id?: ConfigurationTriggerType) => void;
  isFilter?: boolean;
  label?: string;
  emptyOptionText?: string;
  showEmptyOption?: boolean;
  error?: React.ReactNode;
  onBlur?: () => void;
  inline?: boolean;
  clearable?: boolean;
  required?: boolean;
  disabled?: boolean;
  selectMaxWidth?: number;
};

function ConfigurationTriggerTypeSelect({
  selectedId,
  onChangeId,
  isFilter = false,
  label = 'Tipo de activación:',
  emptyOptionText = 'Seleciona un tipo',
  showEmptyOption = false,
  error,
  onBlur,
  inline,
  clearable = false,
  required = false,
  disabled = false,
  selectMaxWidth,
}: Readonly<Props>) {
  const serviceStatusOptions = useMemo(() => {
    const coreOptions = CONFIGURATION_TRIGGER_TYPE_OPTIONS;
    const options = showEmptyOption
      ? [
          {
            id: undefined,
            label: isFilter ? 'Todos' : emptyOptionText,
          },
          ...coreOptions,
        ]
      : coreOptions;
    return options;
  }, []);

  const onSelectedChange = (params: OnChangeParams) => {
    if (params.option?.id) {
      onChangeId && onChangeId(params.option.id as ConfigurationTriggerType);
    } else {
      onChangeId && onChangeId(undefined);
    }
  };

  return (
    <EnhancedLabeledSelect
      label={label}
      options={serviceStatusOptions}
      value={showEmptyOption || selectedId !== undefined ? [{ id: selectedId }] : undefined}
      onChange={onSelectedChange}
      fullWidth
      onBlur={() => {
        onBlur && onBlur();
      }}
      searchable
      inline={inline}
      inset={inline}
      error={error}
      required={required}
      clearable={clearable}
      placeholder={emptyOptionText}
      disabled={disabled}
      selectMaxWidth={selectMaxWidth}
    />
  );
}

export default ConfigurationTriggerTypeSelect;
